import React from "react";
import { Link } from "react-router";
import ContentImage from "../../assets/images/Backgrounds/ayurvedic-theme-1.jpg";
import FloatingImageSrc from "../../assets/images/Contents/single-overlay1.png";
import { Button, Typography } from "@material-tailwind/react";

const GoToTreatmentsContent = () => {
  return (
    <>
      <div className="relative pt-5 block1 mb-20">
        <img
          alt="floating-icon"
          className="absolute -top-12 z-10 lg:-top-16  left-0 lg:w-48 lg:h-48 w-36 h-36  rounded-full object-cover m-2 shadow-none animate-wiggle"
          src={FloatingImageSrc}
        />

        <div className="mb-3 rounded-md"
          style={{
            backgroundImage: `url(${ContentImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="bg-black/10 lg:p-8 p-4 rounded-lg">
            <div className="flex items-start justify-start">
              <div className=" md:w-4/6 lg:w-1/2 w-full px-8 mt-2 content-start">
                <p className="leading-tight text-start title_DMSerifText-Regular md:text-lg lg:text-4xl text-md text-gray-300 py-3 my-3">
                  Experience our specially curated Ayurveda treatments designed
                  to meet your wellness needs.
                </p>

                <Link to={"/Treatments"}>
                  <Button
                    variant="text"
                    size={'md'}
                    className="text-white lg:text-lg font-normal  bg-light-green-800 hover:bg-green-600 transition duration-500 ease-in-out"
                  >
                    View Treatments
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GoToTreatmentsContent;
